import englishMessages from 'ra-language-english';
import adminTranslations from './admin';

const Translation = {
  ...englishMessages,
  ...adminTranslations,
  resources: {
    ...adminTranslations.resources,
    user: {
      name: "User",
    }
  },
  ra: {
    ...englishMessages.ra,
    page: {
      ...englishMessages.ra.page,
      general: "General Info.",
      simple_acl: "Simple ACL",
    },
    action: {
      ...englishMessages.ra.action,
      search_copy: "Search & Copy",
      clone: "Clone",
      html_editor: "HTML Editor",
      file_manager: "File Manager",
      links_manager: "Link Manager",
      qr_code_generator: "QR Code Generator",
    },
  },
  undefined: "undefined",
  null: "null",
  myroot: {
    notify: {
      auth: {
        sendActivationEmail: "AAA",
        passwordRegen: "New Password: %{newPassword}",
        changePassword: {
          success: "New password applied.",
          fail: "Change Password failed."
        }
      },
      recordExtra: {
        lock: "%{recordCaption} has be locked",
        unlock: "%{recordCaption} has be unlocked",
        active: "%{recordCaption} is now active",
        deactive: "%{recordCaption} is now deactive"
      }
    }
  },
  menu: {
    user: "Users",
    saleables: "Saleables",
    crm: "Customer Relationship",
    misc: "Misc.",
    cms: "CMS",
    site_content: "Site Content",
    feature: "Feature",
    maintenance: "Maintenance",
    my_profile: "My Profile",
  },
  __: "END"
}

export default Translation;
